import { Flex } from '@grupoboticario/flora-react';
import { CheckCircleFillIcon } from '@grupoboticario/flora-react-icons';
import { Link } from 'react-router-dom';

import { ResponsiveFloraTypography } from 'components/ResponsiveFloraTypography';
import config from 'config';
import { useTracking } from 'hooks';

export const MessagePrivacyPolicies = () => {
  const { sendDataToGTM } = useTracking();

  const handlePrivacyPolicies = () => {
    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: 'interaction_alterar_celular',
        cd_interaction_detail: 'click:politica-de-privacidade',
      },
    });
  };

  return (
    <Flex direction='column' gap='$2' css={{ marginBottom: '$3' }}>
      <Flex
        gap='$2'
        align='center'
        css={{
          marginBottom: '$3',
        }}
      >
        <CheckCircleFillIcon size={16} color='$success-standard' />
        <ResponsiveFloraTypography
          fontSize='exceptionsAuxiliar'
          fontWeight='regular'
          color='$nonInteractivePredominant'
        >
          Número preenchido corretamente.
        </ResponsiveFloraTypography>
      </Flex>
      <Flex direction='column'>
        <ResponsiveFloraTypography
          fontSize='bodySmallShort'
          fontWeight='bold'
          color='$backgroundAltSecondary'
        >
          Ao solicitar a alteração, você está ciente de que os seus dados serão tratados de acordo
          com a nossa{' '}
          <Link to={config.privacyPolicies.site} target='_blank' rel='noopener noreferrer'>
            <ResponsiveFloraTypography
              onClick={handlePrivacyPolicies}
              color='$backgroundAltPrimary'
              as='p'
              fontSize='bodySmallShort'
              fontWeight='regular'
              textDecoration='underline'
            >
              {config.privacyPolicies.title}
            </ResponsiveFloraTypography>
          </Link>
        </ResponsiveFloraTypography>
      </Flex>
    </Flex>
  );
};
